import { render, staticRenderFns } from "./dashContent.vue?vue&type=template&id=5da5c3af&scoped=true&"
import script from "./dashContent.vue?vue&type=script&lang=js&"
export * from "./dashContent.vue?vue&type=script&lang=js&"
import style0 from "./dashContent.vue?vue&type=style&index=0&id=5da5c3af&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5c3af",
  null
  
)

export default component.exports